import { render, staticRenderFns } from "./gpy.vue?vue&type=template&id=728d3bca&scoped=true"
import script from "./gpy.vue?vue&type=script&lang=js"
export * from "./gpy.vue?vue&type=script&lang=js"
import style0 from "./gpy.vue?vue&type=style&index=0&id=728d3bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d3bca",
  null
  
)

export default component.exports